export class Claim {
    type: string
    value: string
}
